import styled from '@emotion/styled';
import '../../../assets/colors.scss';
const TermsAndConditionsPageStyle = styled('div')`
    background: var(--white);
    border: 1px solid var(--sand-400);
    border-radius: 6px;
    padding: 32px;
    margin-bottom: 2rem;
    line-height: 1.4;

    .title {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 24px;
    }

    ul {
        list-style: disc;
    }

    h2,
    p {
        margin-bottom: 16px;
    }

    @media screen and (max-width: 767px) {
        padding: 24px;
    }
    @media print {
        break-inside: avoid;
        page-break-inside: avoid;
        margin-top: 24px;
    }
`;
export default TermsAndConditionsPageStyle;
